// extracted by mini-css-extract-plugin
module.exports = {"routeHeader":"collections_routeHeader_1nZA_","addButton":"collections_addButton_2hnt5"};